// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3jlLK","title":"AfterFrontImage_title__1rYqh"};